export default "immagini/logo-completo-semplice-HB+BW.svg"